import React from 'react';

import { EMPTY_FUNCTION } from '@travel/traveler-core/constants';
import { cx } from '@travel/utils';

import LikeIcon from './LikeIcon';

import styles from './likeButton.module.scss';

import type { LikeIconStyle } from './LikeIcon';
import type { MouseEvent, KeyboardEventHandler } from 'react';
export type Props = {
  className?: string;
  likeIconClassName?: string;
  buttonClassName?: string;
  /** flag to define `like` status */
  isLiked?: boolean;
  /** size of like icon */
  likeIconSize?: number;
  /** callback function when icon is clicked */
  onClick?: (event: MouseEvent | React.KeyboardEvent<HTMLDivElement>) => void;
  /** callback function when key is pressed on icon */
  onKeyDown?: KeyboardEventHandler;
  /** true if we will need the gold version */
  iconStyle?: LikeIconStyle;
};

function LikeButton(props: Props) {
  const {
    className,
    likeIconClassName,
    buttonClassName,
    isLiked = false,
    likeIconSize = 24,
    onClick = EMPTY_FUNCTION,
    onKeyDown,
    iconStyle,
  } = props;

  return (
    <div className={cx(styles.wrapper, className)}>
      <button
        className={cx(styles.iconWrapper, buttonClassName)}
        // TODO: (A11Y) Add translated labels
        aria-label={isLiked ? 'Unlike' : 'Like'}
        data-testid="likeButton-button"
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        <LikeIcon
          className={likeIconClassName}
          color="lightGrey"
          isLiked={isLiked}
          iconStyle={iconStyle}
          size={likeIconSize}
        />
      </button>
    </div>
  );
}

export default LikeButton;
